import { useGetListingDetailsV3Query } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';
import { useGetListingDetailsV3Query as useGetListingDetailsV3QueryApp } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.hooks';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
// All consumers should use the centralized useUnifiedDetails hook
// which will stay up to date with the various version bumps
// until things stabilize for release
export function useUnifiedDetailsV3({
  appContext,
  slug,
  language,
  skip,
  clientTimeout
}) {
  const variables = slug ? language ? {
    slug,
    language
  } : {
    slug
  } : undefined;
  const context = clientTimeout !== undefined ? {
    timeout: clientTimeout
  } : undefined;
  const {
    data: unifiedDetailsDataInApp,
    loading: unifiedDetailsLoadingInApp,
    error: unifiedDetailsErrorInApp
  } = useGetListingDetailsV3QueryApp({
    variables,
    skip: skip || !slug || appContext !== 'app',
    context
  });
  const {
    data: unifiedDetailsDataPublic,
    loading: unifiedDetailsLoadingPublic,
    error: unifiedDetailsErrorPublic
  } = useGetListingDetailsV3Query({
    variables,
    skip: skip || !slug || appContext !== 'public',
    context
  });
  const unifiedDetailsData = appContext === 'app' ? unifiedDetailsDataInApp : unifiedDetailsDataPublic;

  // @ts-expect-error untyped BE response
  const parsedUnifiedDetailsData = unifiedDetailsData !== null && unifiedDetailsData !== void 0 && unifiedDetailsData.listing ? convertFieldValueAvroToJson(unifiedDetailsData.listing) : {};
  return {
    unifiedDetailsData: parsedUnifiedDetailsData,
    unifiedDetailsLoading: appContext === 'app' ? unifiedDetailsLoadingInApp : unifiedDetailsLoadingPublic,
    unifiedDetailsError: appContext === 'app' ? unifiedDetailsErrorInApp : unifiedDetailsErrorPublic
  };
}